import { render, staticRenderFns } from "./NotificationEdit.vue?vue&type=template&id=17d8a6ae&scoped=true&"
import script from "./NotificationEdit.vue?vue&type=script&lang=js&"
export * from "./NotificationEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d8a6ae",
  null
  
)

export default component.exports